import { FC } from 'react';
import HotelsCarousel from 'components/HotelsCarousel/HotelsCarousel';
import Container from 'components/container';
import { useMediaQuery } from '@mui/material';
import Link from 'next/link';
import { navigationPaths } from 'data/constants';
import { our_hotels } from 'data/translationKeys';
import useLocalised from 'customHooks/useLocalised/useLocalised';

const Hotels: FC<{}> = ({}) => {
  const isMobile = useMediaQuery(`(max-width:650px)`);
  const our_hotels_text = useLocalised(our_hotels);
  return (
    <Container className="hotels-container">
      <HotelsCarousel
        showControlls={isMobile ? false : true}
        className="hotels-container__hotel-carousel"
      />
      <div className="hotels-container__explore">
        <Link href={navigationPaths.OUR_HOTELS}>
          <a
            area-label={our_hotels_text}
            className="linkButton"
            target="_blank"
          >
            Explore
          </a>
        </Link>
      </div>
    </Container>
  );
};

export default Hotels;
